import { render, staticRenderFns } from "./UserProfileBio.vue?vue&type=template&id=f1807dae&scoped=true"
import script from "./UserProfileBio.vue?vue&type=script&lang=js"
export * from "./UserProfileBio.vue?vue&type=script&lang=js"
import style0 from "./UserProfileBio.vue?vue&type=style&index=0&id=f1807dae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1807dae",
  null
  
)

export default component.exports